import { render, staticRenderFns } from "./FollowCards.vue?vue&type=template&id=2a58d5a3&scoped=true&"
import script from "./FollowCards.vue?vue&type=script&lang=js&"
export * from "./FollowCards.vue?vue&type=script&lang=js&"
import style0 from "./FollowCards.vue?vue&type=style&index=0&id=2a58d5a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a58d5a3",
  null
  
)

export default component.exports